var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('el-row',{staticStyle:{"background-color":"#34495e","opacity":"0.85"}},[_c('a',{attrs:{"href":"/#/"}},[_c('el-image',{attrs:{"src":require('@/assets/logo.png')}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#ffa71d","font-size":"14px","position":"absolute","margin-left":"10px"}},[_vm._v("问卷调查")])],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ffb5cf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/DwHeader.vue
// module id = null
// module chunks = 